var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading_data"}),_c('div',{staticClass:"load"},[_c('v-progress-circular',{attrs:{"width":3,"color":"#82D5C5","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }